export const ORGANISATION_EPOCH_ISO = new Date(0).toISOString();

export function hasSyncedLastRefreshDate(lastRefreshDate) {
  if (!lastRefreshDate) return false;

  const ms = new Date(lastRefreshDate).getTime();

  return Number.isFinite(ms) && ms !== 0;
}

export function hasOrganisationSynced(organisation) {
  return hasSyncedLastRefreshDate(organisation?.lastRefreshDate);
}
